
export const contactPageConfig = {
    form: {
        title: "Contact us",
        fields: [
            { label: "First name", name: "First-name", type: "text" },
            { label: "Last name", name: "Last-name", type: "text" },
            { label: "Email", name: "Work-email", type: "email" },
            { label: "Phone number", name: "Phone-number", type: "tel", optional: true },
            { label: "Message", name: "Message", type: "textarea" }
        ],
        submitText: "Send message",
        disclaimer: 'By submitting this form you are agreeing to GradBrew <a href="/legal/gdpr-policy" target="_blank">GDPR Compliance Policy</a> and <a href="/legal/privacy-policy">Privacy Policy</a>.',
        success: {
            title: "Thank you!",
            message: "Your query has been received! A member from our team will be in touch shortly.",
            link: { href: "/", text: "Go to homepage" }
        },
        error: "Something went wrong while submitting the form. Please try again."
    },
    schedule: {
        heading: "Schedule a Call",
        description: "Prefer speaking to someone? Book a free 15 minute call and we'll walk you through how GradBrew can help.",
        link: { href: "/lets-talk", text: "Book a 15‑min Call" },
        calendarUrl: "https://cal.com/gradbrew/15min"
    }
};